import api from "../axios_service";

export async function listaDeContasReceber(filtros) {
  const response = await api.get(
    `/relatorios/contasreceber${filtros ? filtros : ""}`
  );
  return response.data.result;
}